import { NgModule } from '@angular/core';
import { AbbIconComponent } from '@components/abb-icon/abb-icon.component';
import { AbbButtonComponent } from '@components/abb-button/abb-button.component';
import { AbbTableComponent } from '@components/abb-table/abb-table.component';
import { ABBLogoComponent } from '@components/abb-logo/abb-logo';
import { AbbActionsMenuComponent } from '@components/abb-actions-menu/abb-actions-menu.component';
import { AbbSwitchComponent } from '@components/abb-switch/abb-switch.component';
import { AbbMiniCardSelectionComponent } from '@components/abb-mini-cards-selection/abb-mini-card-selection';
import { AbbAvatarComponent } from '@components/abb-avatar/abb-avatar.component';

@NgModule({
  imports: [
    ABBLogoComponent,
    AbbButtonComponent,
    AbbTableComponent,
    AbbIconComponent,
    AbbActionsMenuComponent,
    AbbSwitchComponent,
    AbbMiniCardSelectionComponent,
    AbbAvatarComponent,
  ],
  exports: [
    ABBLogoComponent,
    AbbButtonComponent,
    AbbTableComponent,
    AbbIconComponent,
    AbbActionsMenuComponent,
    AbbSwitchComponent,
    AbbMiniCardSelectionComponent,
    AbbAvatarComponent,
  ],
})
export class AbbCommonModule {}
